import { render, staticRenderFns } from "./view-toggle.vue?vue&type=template&id=0f0ecd56&scoped=true"
import script from "./view-toggle.vue?vue&type=script&lang=js"
export * from "./view-toggle.vue?vue&type=script&lang=js"
import style0 from "./view-toggle.vue?vue&type=style&index=0&id=0f0ecd56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0ecd56",
  null
  
)

export default component.exports